import React from 'react';
import { Close, Sms, Email, WhatsApp } from '@mui/icons-material';

/**
 * Modal pour choisir le moyen d'envoi du lien (SMS, Email, WhatsApp).
 * Ouvre l'app correspondante avec le lien pré-rempli au lieu de copier dans le presse-papier.
 */
export const ResendMethodModal = ({ show, onClose, link, onSent }) => {
    if (!show || !link) return null;

    const linkUrl = link.link || `${typeof window !== 'undefined' ? window.location.origin : ''}/pay/${link.id}`;
    const message = `${link.title || 'Lien de paiement'} - ${link.amount} ${link.currency}\n${linkUrl}`;
    const customer = link.customer || {};
    const email = customer.email || link.clientContact || '';
    const phone = customer.phoneNumber || (typeof link.clientContact === 'string' && link.clientContact.replace(/\D/g, '').length >= 9 ? link.clientContact : '');
    const zip = customer.zip || '243';
    const fullPhone = phone ? (zip && !phone.startsWith('+') ? `${zip}${phone.replace(/^0+/, '')}` : phone) : '';

    const canEmail = !!email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const canSms = !!fullPhone;
    const canWhatsapp = !!fullPhone;

    const handleSendBy = (channel) => {
        const encoded = encodeURIComponent(message);
        if (channel === 'email') {
            window.location.href = `mailto:${email}?subject=${encodeURIComponent(link.title || 'Lien de paiement')}&body=${encoded}`;
        } else if (channel === 'sms') {
            window.location.href = `sms:${fullPhone}?body=${encoded}`;
        } else if (channel === 'whatsapp') {
            const waNumber = fullPhone.replace(/\D/g, '');
            window.open(`https://wa.me/${waNumber}?text=${encoded}`, '_blank');
        }
        onSent?.();
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
            <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 border border-slate-200">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-slate-900">Envoyer le lien par</h3>
                    <button type="button" onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
                        <Close className="text-slate-500" />
                    </button>
                </div>
                <p className="text-sm text-slate-600 mb-4">
                    Choisissez le canal d'envoi. Votre application (messagerie, email, WhatsApp) s'ouvrira avec le lien pré-rempli.
                </p>
                <div className="space-y-2">
                    <button
                        type="button"
                        onClick={() => handleSendBy('sms')}
                        disabled={!canSms}
                        className="w-full flex items-center justify-center space-x-2 px-4 py-3 rounded-xl border-2 border-amber-200 bg-amber-50 text-amber-800 font-semibold hover:bg-amber-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        <Sms className="text-lg" />
                        <span>SMS</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => handleSendBy('email')}
                        disabled={!canEmail}
                        className="w-full flex items-center justify-center space-x-2 px-4 py-3 rounded-xl border-2 border-blue-200 bg-blue-50 text-blue-800 font-semibold hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        <Email className="text-lg" />
                        <span>Email</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => handleSendBy('whatsapp')}
                        disabled={!canWhatsapp}
                        className="w-full flex items-center justify-center space-x-2 px-4 py-3 rounded-xl border-2 border-emerald-200 bg-emerald-50 text-emerald-800 font-semibold hover:bg-emerald-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        <WhatsApp className="text-lg" />
                        <span>WhatsApp</span>
                    </button>
                </div>
                {(!canEmail || !canSms) && (
                    <p className="mt-3 text-xs text-slate-500">
                        {!canEmail && !canSms && "Aucun email ni téléphone pour ce client."}
                        {!canEmail && canSms && "Ce client n'a pas d'email enregistré."}
                        {canEmail && !canSms && "Ce client n'a pas de numéro enregistré."}
                    </p>
                )}
            </div>
        </div>
    );
};
